export interface PipelineOptions<T extends string | number | object> {
  pipeline: Array<(value: any) => T>;
}

export class FormatPipeline<T extends string | number | object, P = any> {
  public constructor(
    private readonly options: PipelineOptions<T>,
    private readonly _parent: P
  ) {}

  private modifyValue(value: any) {
    if (this.options.pipeline) {
      let _value = value;
      for (const preProcessor of this.options.pipeline) {
        _value = preProcessor(_value);
      }
      return _value;
    }
    return value;
  }

  public call(value: any) {
    return this.modifyValue(value);
  }

  public add(modifier: (value: any) => T) {
    this.options.pipeline.push(modifier);
  }

  public get parent() {
    return this._parent;
  }
}
